/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  DropFollowResponse,
  DropFollowStatusResponse,
  DropReferralStatsResponse,
  PaginatedDropFollowersResponse,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    DropFollowResponseFromJSON,
    DropFollowResponseToJSON,
    DropFollowStatusResponseFromJSON,
    DropFollowStatusResponseToJSON,
    DropReferralStatsResponseFromJSON,
    DropReferralStatsResponseToJSON,
    PaginatedDropFollowersResponseFromJSON,
    PaginatedDropFollowersResponseToJSON,
} from '../models/index';

export interface CreateDropsSlugFollowRequest {
    slug: string;
    dropRef?: string;
    body?: object;
}

export interface DeleteDropsSlugFollowRequest {
    slug: string;
}

export interface GetDropsSlugFollowersRequest {
    slug: string;
    limit?: number;
    offset?: number;
}

export interface GetDropsSlugIsFollowingRequest {
    slug: string;
}

export interface GetDropsSlugMeReferralsRequest {
    slug: string;
    limit?: number;
    offset?: number;
}

/**
 * DropFollowsApi - interface
 * 
 * @export
 * @interface DropFollowsApiInterface
 */
export interface DropFollowsApiInterface {
    /**
     * Follow a Drop. Idempotent for ACTIVE — returns the existing follow.
     * @param {string} slug Drop URL slug
     * @param {string} [dropRef] Referrer user ID for follow attribution
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropFollowsApiInterface
     */
    createDropsSlugFollowRaw(requestParameters: CreateDropsSlugFollowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropFollowResponse>>;

    /**
     * Follow a Drop. Idempotent for ACTIVE — returns the existing follow.
     */
    createDropsSlugFollow(requestParameters: CreateDropsSlugFollowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropFollowResponse>;

    /**
     * Unfollow a Drop. Idempotent.
     * @param {string} slug Drop URL slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropFollowsApiInterface
     */
    deleteDropsSlugFollowRaw(requestParameters: DeleteDropsSlugFollowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Unfollow a Drop. Idempotent.
     */
    deleteDropsSlugFollow(requestParameters: DeleteDropsSlugFollowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * List active followers of a Drop with display info. Public endpoint.
     * @param {string} slug Drop URL slug
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropFollowsApiInterface
     */
    getDropsSlugFollowersRaw(requestParameters: GetDropsSlugFollowersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDropFollowersResponse>>;

    /**
     * List active followers of a Drop with display info. Public endpoint.
     */
    getDropsSlugFollowers(requestParameters: GetDropsSlugFollowersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDropFollowersResponse>;

    /**
     * Returns the authenticated user\'s follow status for a Drop.
     * @param {string} slug Drop URL slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropFollowsApiInterface
     */
    getDropsSlugIsFollowingRaw(requestParameters: GetDropsSlugIsFollowingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropFollowStatusResponse>>;

    /**
     * Returns the authenticated user\'s follow status for a Drop.
     */
    getDropsSlugIsFollowing(requestParameters: GetDropsSlugIsFollowingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropFollowStatusResponse>;

    /**
     * Get the authenticated user\'s referral stats for a Drop — count and list of followers they referred.
     * @param {string} slug Drop URL slug
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DropFollowsApiInterface
     */
    getDropsSlugMeReferralsRaw(requestParameters: GetDropsSlugMeReferralsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropReferralStatsResponse>>;

    /**
     * Get the authenticated user\'s referral stats for a Drop — count and list of followers they referred.
     */
    getDropsSlugMeReferrals(requestParameters: GetDropsSlugMeReferralsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropReferralStatsResponse>;

}

/**
 * 
 */
export class DropFollowsApi extends runtime.BaseAPI implements DropFollowsApiInterface {

    /**
     * Follow a Drop. Idempotent for ACTIVE — returns the existing follow.
     */
    async createDropsSlugFollowRaw(requestParameters: CreateDropsSlugFollowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropFollowResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling createDropsSlugFollow().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['dropRef'] != null) {
            queryParameters['dropRef'] = requestParameters['dropRef'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/drops/{slug}/follow`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropFollowResponseFromJSON(jsonValue));
    }

    /**
     * Follow a Drop. Idempotent for ACTIVE — returns the existing follow.
     */
    async createDropsSlugFollow(requestParameters: CreateDropsSlugFollowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropFollowResponse> {
        const response = await this.createDropsSlugFollowRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unfollow a Drop. Idempotent.
     */
    async deleteDropsSlugFollowRaw(requestParameters: DeleteDropsSlugFollowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling deleteDropsSlugFollow().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/drops/{slug}/follow`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Unfollow a Drop. Idempotent.
     */
    async deleteDropsSlugFollow(requestParameters: DeleteDropsSlugFollowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDropsSlugFollowRaw(requestParameters, initOverrides);
    }

    /**
     * List active followers of a Drop with display info. Public endpoint.
     */
    async getDropsSlugFollowersRaw(requestParameters: GetDropsSlugFollowersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDropFollowersResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getDropsSlugFollowers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/drops/{slug}/followers`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDropFollowersResponseFromJSON(jsonValue));
    }

    /**
     * List active followers of a Drop with display info. Public endpoint.
     */
    async getDropsSlugFollowers(requestParameters: GetDropsSlugFollowersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDropFollowersResponse> {
        const response = await this.getDropsSlugFollowersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the authenticated user\'s follow status for a Drop.
     */
    async getDropsSlugIsFollowingRaw(requestParameters: GetDropsSlugIsFollowingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropFollowStatusResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getDropsSlugIsFollowing().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/drops/{slug}/is-following`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropFollowStatusResponseFromJSON(jsonValue));
    }

    /**
     * Returns the authenticated user\'s follow status for a Drop.
     */
    async getDropsSlugIsFollowing(requestParameters: GetDropsSlugIsFollowingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropFollowStatusResponse> {
        const response = await this.getDropsSlugIsFollowingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the authenticated user\'s referral stats for a Drop — count and list of followers they referred.
     */
    async getDropsSlugMeReferralsRaw(requestParameters: GetDropsSlugMeReferralsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DropReferralStatsResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getDropsSlugMeReferrals().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/drops/{slug}/me/referrals`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DropReferralStatsResponseFromJSON(jsonValue));
    }

    /**
     * Get the authenticated user\'s referral stats for a Drop — count and list of followers they referred.
     */
    async getDropsSlugMeReferrals(requestParameters: GetDropsSlugMeReferralsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DropReferralStatsResponse> {
        const response = await this.getDropsSlugMeReferralsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
